import gql from 'graphql-tag'

export const GROUP_REPORT = gql`
    query($input: ReportByGroupInput!) {
        reportByGroup(input: $input)
    }
`
